import { RecapFile } from '../files/file';
import { authFetch } from '../util/api';
import { fileItemPath, filesPartnerVideosPath } from '../util/fileApi';
import { PartnerType } from './partner';

export async function getPartnerFile(workspaceId: string, partner: PartnerType, videoId: string) {
  const response = await authFetch(
    filesPartnerVideosPath(workspaceId, { partner, videoIds: videoId }),
  );
  return (response.files?.[0] || null) as RecapFile | null;
}

export function getRecapFile(workspaceId: string, fileId: string): Promise<RecapFile | undefined> {
  return authFetch(fileItemPath(workspaceId, fileId));
}
